/**
 * @file API service — characterizationFactorsPublicService.
 */

import axiosClient from "../api/axiosClient";
import { API_URLS } from "../constants/apiUrls";

/** Public list item (active factors only, ordered by sortOrder on the server). */
export interface CharacterizationFactorPublic {
  id: number;
  fuelMix: string;
  unit: string;
  characterizationFactor: string;
  sortOrder: number;
}

/** Exported function — fetch Active Characterization Factors. */
export async function fetchActiveCharacterizationFactors(): Promise<
  CharacterizationFactorPublic[]
> {
  const res = await axiosClient.get<{
    success?: boolean;
    data?: CharacterizationFactorPublic[];
    message?: string;
  }>(API_URLS.CHARACTERIZATION_FACTORS);

  if (res.data?.success === false) {
    throw new Error(res.data.message || "Failed to load characterization factors");
  }
  const data = res.data?.data;
  if (!Array.isArray(data)) return [];
  return [...data].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
}
